import * as React from "react";
import getConfig from "next/config";
import { useBloomreachPageRoutes, CmsHeadTags, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { ReviewsProvider, ReviewWrite } from "@grandvisionhq/reviews";
import { useFeatureToggles } from "@grandvisionhq/state";
import "@grandvisionhq/reviews/dist/index.css";
const { publicRuntimeConfig } = getConfig();
const selfUrl = publicRuntimeConfig.selfUrl || "";
const { apiKey: powerReviewsApiKey, groupId, opcoId } = publicRuntimeConfig.powerReviews;
const Page = () => {
  const { routes } = useBloomreachPageRoutes();
  const { isReviewsEnabled } = useFeatureToggles();
  const reviewsConfig = React.useMemo(
    () => ({
      groupId,
      opcoId,
      apiKey: powerReviewsApiKey,
      writeReviewPath: routes["write-review"] ?? ""
    }),
    [routes]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, null, isReviewsEnabled && /* @__PURE__ */ React.createElement("link", { rel: "preconnect", href: "https://ui.powerreviews.com" })), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }), /* @__PURE__ */ React.createElement(ReviewsProvider, { enabled: isReviewsEnabled, config: reviewsConfig }, /* @__PURE__ */ React.createElement(ReviewWrite, { selfUrl })), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }));
};
export {
  Page
};
//# sourceMappingURL=write-review.js.map
